import { Link, useParams } from "react-router-dom";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../../redux/cartReducer";
import "./Card.scss";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Card = ({ item }) => {
  const [showPreview, setShowPreview] = useState(false);

  const handlePreviewOpen = () => {
    setShowPreview(true);
  };

  const handlePreviewClose = () => {
    setShowPreview(false);
  };

  const [previewPosition, setPreviewPosition] = useState({ top: 0, left: 0 });

  const dispatch = useDispatch();

  const cartData = useSelector((state) =>
    state.cart.products?.find((i) => i.id === item.id),
  );

  const quantity = cartData?.quantity || 0;
  const products = useSelector((state) => state.cart.products);

  const getQuantityInCart = () => {
    const cartItem = products.find((item) => item.id);
    return cartItem
      ? {
          id: cartItem.id,
          max_order_value: cartItem.max_order_qut,
          quantity: cartItem.quantity,
        }
      : { id: null, max_order_value: 2, quantity: 2 }; // Default values for quantity if no item is found
  };

  const cartDatas = getQuantityInCart();

  const handleAddToCart = () => {
    // Get the number of items in the cart with flash_sale === true
    const flashSaleItemsInCart = products.filter(
      (product) => product.flash_sale === true,
    ).length;

    if (item.attributes.outofstock) {
      toast.error("Temporary out of stock", {
        position: "bottom-left",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        style: {
          color: "white",
          boxShadow: "none",
          backgroundColor: "#FFD6D7",
          color: "black",
        },
      });
    } else if (
      item.attributes.flash_sale &&
      flashSaleItemsInCart >= item.attributes.flash_sale_product_pcs
    ) {
      // Prevent adding more than 3 flash_sale items
      toast.error("You can only add up to 3 flash sale items to the cart", {
        position: "bottom-left",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        style: {
          color: "white",
          boxShadow: "none",
          backgroundColor: "#FFD6D7",
          color: "black",
        },
      });
    } else if (
      quantity < item.attributes.max_order_qut ||
      item.attributes.max_order_qut !== 2
    ) {
      // Adds item to cart if max order limit is not reached or it has a different max order limit
      dispatch(
        addToCart({
          id: item.id,
          title: item.attributes.title,
          desc: item.attributes.desc,
          weight: item.attributes.weight,
          price: item.attributes.price,
          img: item.attributes.img.data.attributes.url,
          quantity: 1,
          max_order_qut: item.attributes.max_order_qut,
          flash_sale: item.attributes.flash_sale,
          flash_sale_product_pcs: item.attributes.flash_sale_product_pcs,
        }),
      );
    }
  };

  const showToastMessage = () => {
    toast.success("Success Notification !", {
      position: toast.POSITION.BOTTOM_LEFT,
    });
  };

  return (
    <>
      <div className="card">
        <div className="card_in">
          <div className="image" onClick={handlePreviewOpen}>
            {item.attributes.discount && (
              <span> {item.attributes.discoamount}</span>
            )}
            {!!item.attributes.outofstock && (
              <span className="span2">out of stock</span>
            )}
            <img
              src={
                process.env.REACT_APP_UPLOAD_URL +
                item.attributes?.img?.data?.attributes?.url
              }
              alt=""
              className="mainImg"
            />
            <img
              src={
                process.env.REACT_APP_UPLOAD_URL +
                item.attributes?.img2?.data?.attributes?.url
              }
              alt=""
              className="secondImg"
            />
          </div>

          <div className="data">
            <p>{item.attributes.title}</p>
            <small>Weight: {item.attributes.weight}</small>
            <div className="prices">
              <h2>{item?.attributes.oldprice}</h2>
              <span>
                <small>AED</small> {item?.attributes.price}
              </span>
            </div>

            {cartDatas === item.id ? (
              <div className="addtocart">
                <div className="add">
                  <AddShoppingCartIcon fontSize="40" />
                  ADD TO CART
                </div>
              </div>
            ) : (
              <div className="addtocart">
                <div className="add" onClick={handleAddToCart}>
                  <AddShoppingCartIcon fontSize="40" />
                  ADD TO CART
                </div>
              </div>
            )}
          </div>
          <Link to={`/product/${item.id}`}>
            <span>View Details</span>
          </Link>
        </div>
      </div>

      {/* Modal is outside card_in so overflow:hidden doesn't trap it 
      {showPreview && (
        <div className="centeredPreview" onClick={handlePreviewClose}>
          <div className="popupContent" onClick={(e) => e.stopPropagation()}>
            <button className="closeBtn" onClick={handlePreviewClose}>
              ×
            </button>
            <img
              src={
                process.env.REACT_APP_UPLOAD_URL +
                item.attributes?.img?.data?.attributes?.url
              }
              alt="Preview"
            />
          </div>
        </div>
      )}
        */}
    </>
  );
};

export default Card;
